/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const PriceSelectorFragment = {
  PriceSelector: gql`
    fragment PriceSelectorQuery on aarpPriceSelector_Entry {
      cardText
      cardTitle
      productCardBackgroundColor
      productCardColor
      selectorInstructions
      typeHandle
      selectorList {
        ... on selectorListBlock_Entry {
          state
          disclaimer
          product {
            ... on xgritProduct_Entry {
              productPageUrl
              productState
              xgritBundleCoupon
              xgritCoupon
              xgritProductId
            }
          }
        }
      }
    }
  `,
};
